import React, { useState } from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Thumbs } from 'swiper/modules';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Col from '@common/Col';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

import Buttons from '@common/blocks/flex/Buttons';
import Images from '@common/blocks/flex/Images';

const FlexSlider = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        <Swiper
          modules={[Pagination, Navigation, A11y, Thumbs]} 
          centeredSlides
          className='swiper-flex-slider'
          slidesPerView={1}
          spaceBetween={20}
          navigation={true}
          thumbs={{ swiper: thumbsSwiper }}
          >
          {list.map((item, index) => (
            <SwiperSlide key={index} className='d-flex flex-column'>
              <Row className='row-cols-lg-2 align-items-center'>
                {(item.text || item.buttons) &&
                  <div>
                    {(showTitle && title) && <SmallTitle>{title}</SmallTitle>}
                    {(item.showTitle && item.title) && <SmallTitle>{item.title}</SmallTitle>}
                    {item.text &&
                      <RichText
                        json={item.text}
                        h1='mb-3'
                        h2='mb-3'
                        p='mb-3'
                        a='fs-16'
                        ul={item.listClass}
                      />
                    }
                    {item.buttons && 
                      <Buttons data={item} />
                    }
                  </div>
                }
                {item.images &&
                  <Images data={item} />
                }
              </Row>
            </SwiperSlide>
          ))}
        </Swiper>
        <Swiper
          onSwiper={setThumbsSwiper}
          watchSlidesProgress={true}
          slidesPerView={list.length}
          spaceBetween={75}
          className={'swiper-flex-slider-thumbs mt-3 d-none d-lg-block'}
          >
          {list.map((item, index) => (
            <SwiperSlide key={index}>
              <Col>
                <div className={clsx({[`text-${item.bgColour}`]:item.bgColour})}>{`0${index+1}`}</div>
                <div>{item.title}</div>
              </Col>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Section>
  )
}

export default FlexSlider
